// Cognito User Pool config is wired to build-args (like the identity pool and
// S3), so a production build points Auth.signIn() at the real prod pool. Absent
// (local/develop) it falls back to the dummy — safe there because develop logs
// in through the mock-JWT bypass and never exercises real Cognito. All three AWS
// region fields share one arg: in every deployment they are the same region.
// (aws_project_region and aws_appsync_region are inert in this app — no Analytics,
// and the API uses API_KEY + a Bearer header, never SigV4 — but are set correctly
// so no dummy region survives in the bundle.)
const awsmobile = {
    "aws_project_region": process.env.REACT_APP_COGNITO_REGION || "us-east-2",
    "aws_cognito_identity_pool_id":
        process.env.REACT_APP_IDENTITY_POOL_ID || "us-east-2:dummy-id-pool-id-12345",
    "aws_cognito_region": process.env.REACT_APP_COGNITO_REGION || "us-east-2",
    "aws_user_pools_id": process.env.REACT_APP_USER_POOLS_ID || "us-east-2_dummyUserPool",
    "aws_user_pools_web_client_id":
        process.env.REACT_APP_USER_POOLS_WEB_CLIENT_ID || "dummyUserPoolWebClientId12345",
    "oauth": {},
    "aws_cognito_username_attributes": ["EMAIL"],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": process.env.REACT_APP_VPORT_API_URL || "http://localhost:5000/graphql",
    "aws_appsync_region": process.env.REACT_APP_COGNITO_REGION || "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-dummyApiKey123456789012345",
    // Storage: baked via build-args in develop (vend-repo-storage-develop). Omit in other envs.
    ...(process.env.REACT_APP_S3_BUCKET
        ? {
              aws_user_files_s3_bucket: process.env.REACT_APP_S3_BUCKET,
              aws_user_files_s3_bucket_region:
                  process.env.REACT_APP_S3_REGION || "us-east-2",
          }
        : {}),
};

export default awsmobile;
